
import { i18nText } from '@/locales';

import {Component, Vue} from "vue-property-decorator";
import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";
import PageTitle from "@/UI/components/common/PageTitle.vue";
@Component({
  components: {PageTitle}
})
export default class WorkerTasks extends Vue {
  loading = false;
  data: any[] = [];
  pagination = {
    showSizeChanger: true,
    pageSize: 10,
    total: 500,
  }
  get columns(): ITableColumn[] {
    return TablesStore.workerTasksColumns;
  }
  async created(): Promise<void> {
    for (let i = 0; i < 100; i++) {
      this.data.push({
        key: (i + 1).toString(),
        filial: 'Epilier Казань',
        name: 'Продать крем для красоты',
        client: i.toString() + 'Ибрагимова Александра',
        status: i18nText("В работе"),
        term: '20.06.2021, 9:00',
        date: '16.06.2021, 11:00',
      })
    }
    this.pagination.total = this.data.length
  }
}
